import styled from "@emotion/styled";
import { color } from "styles/color";
import { Table } from "antdv5";

export const ConnectText = styled.div`
  z-index: 10;
  display: flex;
  flex-flow: row;
  text-decoration: none;
  &:before {
    content: "";
    position: absolute;
    background-color: ${(props: { link: number; decoration: boolean }) =>
      props.link === 1 ? "#8cf08c" : "#fd345c"};
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .expired {
    text-decoration: ${(props) => (props.decoration ? "line-through" : "none")};
    color: ${(props) => (props.link === 1 ? "#086208" : "#96112b")};
    margin-left: 0.3rem;
    z-index: 0;
  }
`;
export const Section = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 1rem;
  @media (min-width: 768px) {
    flex-flow: row nowrap;
    align-items: baseline;
    div:nth-last-of-type(1) {
      margin-left: auto;
      margin-right: 0;
    }
  }
  .btn {
    padding: 0.2rem 0.5rem;
    border: 1px solid ${color.markedSecondary};
    color: ${color.markedSecondary};
    border-radius: 0.2rem;
    cursor: pointer;
    transition: all 0.3s ease-out;
    max-width: 100px;
    &:hover {
      background-color: ${color.markedSecondary};
      color: white;
    }
  }
  .text {
    color: ${color.primaryBlue};
  }
  .text,
  .btn {
    margin-top: 1rem;
    order: 2;
    margin-right: 1rem;
    @media (min-width: 768px) {
      order: 1;
      margin-top: 0;
    }
  }
`;
export const TableOutter = styled.div`
  .unlinkDevice {
    font-size: 1rem;
    margin: -8px;
    padding-bottom: 0.5rem;
    color: ${color.markedSecondary};
    background-color: ${color.secondary};
  }
  .ant-table-container {
    border: 0;
    border-left: 1px solid #f0f0f0;
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    border-bottom: none;
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
      border-right: 0 !important;
    }
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.primaryBlue};
    border-right: 1px solid ${color.primaryBlue} !important;
    &:first-of-type {
      border-left: 1px solid ${color.primaryBlue};
    }
  }
  .ant-table-container {
    border: 0 !important;
  }
  .ant-table-row {
    /* &:nth-of-type(5n+2),&:nth-of-type(5n+3),&:nth-of-type(5n+4),&:nth-of-type(5n+5),&:nth-of-type(5n+6){
      background-color: #ffffff;
    }
    &:nth-of-type(10n+7),&:nth-of-type(10n+8),&:nth-of-type(10n+9),&:nth-of-type(10n+10),&:nth-of-type(10n+11){
      background-color: ${color.secondary};
    } */
    &:nth-of-type(odd) {
      //3n+4
      background-color: ${color.secondary};
    }
    &:nth-of-type(even) {
      //3n+4
      background-color: white;
    }
    @media print {
      page-break-inside: avoid;
    }
  }
  .ant-table-sticky-scroll-bar {
    position: absolute;
    bottom: 30%;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    @media print {
      display: none;
    }
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
`;
export const StyledTable = styled(Table)`
  padding: 2rem 0;
  position: relative;
  &:after {
    content: "";
    width: 111.1111111%;
    height: 100%;
    background-color: ${color.secondary};
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(-5%);
    z-index: -1;
  }
  @media (min-width: 768px) {
    padding: 3rem 0;
  }
  th.ant-table-cell {
    background-color: ${color.markedSecondary} !important;
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.markedSecondary};
    border-right: 1px solid ${color.markedSecondary} !important;
    &:first-of-type {
      border-left: 1px solid ${color.markedSecondary};
    }
  }
  .ant-table-container {
    background-color: ${color.secondary} !important;
  }
  .ant-table-title {
    border: none !important;
  }
`;
export const StyledSecondTable = styled(Table)`
  padding: 3rem 0;
  th.ant-table-cell {
    background-color: ${color.secondary} !important;
    color: ${color.default};
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.secondary};
    border-right: 1px solid ${color.secondary} !important;
    &:first-of-type {
      border-left: 1px solid ${color.secondary};
    }
  }
  .ant-table-title {
    border: none !important;
  }
`;
